<template>
	<div grey-back>
		<v-dialog v-model="dialog_select_batch" no-click-animation persistent scrollable fullscreen content-class="full-height batch_dialog_container" lazy transition="dialog-bottom-transition">

        	<v-card>
        		<v-toolbar flat>
				    <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
				    <v-toolbar-title class="white--text two-line-title">{{ $parent.Form.selectedBatchType == 2 ? 'Add Series' : 'Add Batches'}}</v-toolbar-title>
                    <!-- <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="fn_newBatch">New Batch</v-btn> -->
				</v-toolbar>

        	  	<v-card-text full-height nopadding grey-back>

                    <div class="batch-form">
                        <v-form full-width>

                            <v-layout wrap pt-2 white-background>
                                <template v-for="(field, index) in batchFields">
                                    <v-flex :class="[batchFields.length == 1 ? 'xs12 sm12 md12' : 'xs6 sm6 md6']" form-item :key="index" v-if="field.id != 'opening' && fn_fieldVisibilty(field)">
                                        <v-text-field  
                                                :label="field.title" 
                                                v-model="field.value"
                                                placeholder=" " 
                                                v-validate="'required'" 
                                                :data-vv-name="'batch_field' + index" 
                                                :data-vv-as="field.title"
                                                :error-messages="errors.collect('batch_field' + index)"
                                                :hide-details="!errors.has('batch_field' + index)"
                                                required
                                                v-if="field.type == 'string'">
                                        </v-text-field>

                                        <div v-else-if="field.type == 'date'" @click="openDatePicker(field.id, field.value)">
                                            <!-- <v-text-field  
                                                    readonly
                                                    :value="field.value | moment('DD-MMM-YYYY')"
                                                    :label="field.title" 
                                                    placeholder=" " 
                                                    append-icon="arrow_drop_down"
                                                    v-validate="'required'" 
                                                    :data-vv-name="'batch_field' + index" 
                                                    :data-vv-as="field.title"
                                                    :error-messages="errors.collect('batch_field' + index)"
                                                    required
                                                    > -->
                                                <v-text-field  
                                                    readonly
                                                    :value="field.value | moment($root.batchDateFormat)"
                                                    :label="field.title" 
                                                    placeholder=" " 
                                                    append-icon="arrow_drop_down"
                                                    >
                                            </v-text-field>
                                        </div>

                                        <v-text-field  
                                                v-model.number="field.value"
                                                type="number"
                                                :label="field.title" 
                                                placeholder=" " 
                                                v-validate="'required'" 
                                                :data-vv-name="'batch_field' + index" 
                                                :data-vv-as="field.title"
                                                :error-messages="errors.collect('batch_field' + index)"
                                                required
                                                v-else>
                                        </v-text-field>

                                        <div right-align v-if="$root.TransactionSettings.enableBarcodeScan && (field.id=='field1' || field.id=='field2' || field.id=='field3' || field.id=='field4')">
                                            <v-btn small icon nomargin @click="fn_showScanner(field)">
                                                <img src="../../../../assets/icon_barcode_scanner.svg" alt="barcode_scanner">
                                            </v-btn>
                                        </div>
                                        <!-- <v-btn icon small @click="fn_showScanner(field)" v-if="field.id=='field1' || field.id=='field2' || field.id=='field3'"><v-icon>qrcode</v-icon></v-btn> -->
                                    </v-flex>
                                </template>

                                <v-flex xs6 sm6 md6 form-item v-if="$parent.Form.selectedBatchType == 1 && hideQty">
                                    <!-- <v-text-field  
                                        v-model.number="pqty"
                                        type="number"
                                        :label="openingForm ? 'Opening' : 'Quantity'" 
                                        placeholder=" ">
                                    </v-text-field> -->
                                    <v-text-field  
                                        v-model.number="pqty"
                                        type="number"
                                        label="Opening" 
                                        placeholder=" "
                                        v-if="openingForm == 'Opening'">
                                    </v-text-field>

                                    <v-text-field  
                                        v-model.number="pqty"
                                        type="number"
                                        label="Quantity" 
                                        placeholder=" "
                                        v-validate="'decimal:3'" 
                                        data-vv-name="Quantity" 
                                        :error-messages="errors.collect('Quantity')"
                                        v-else>
                                    </v-text-field>

                                    
                                </v-flex>

                                <!-- <v-flex xs12 sm12 md12 right-align form-item>
                                    <div center-align class="pa-2 light-opacity-color" v-if="!fn_areFieldsAvailable()">No fields available to add, enable from settings.</div>
                                    <v-btn block color="primary" @click="fn_addBatch" :disabled="!fn_areFieldsAvailable()">Add</v-btn>
                                </v-flex> -->
                                <v-flex xs12 sm12 md12 right-align form-item>
                                    <v-btn block color="primary" @click="fn_addBatch">Add</v-btn>
                                </v-flex>
                            </v-layout>

                        </v-form>

                    </div>

                    <!-- <div class="added-batches mt-1" v-if="fn_areFieldsAvailable()"> -->
                    <div>
                        <v-subheader class="pr-0" white-background>
                            <div style="word-break: normal;">{{ $parent.Form.selectedBatchType == 2 ? 'Select Series' : 'Select Batches'}}</div> 
                            <v-spacer></v-spacer>
                            <v-text-field placeholder="Search" v-model="searchValue" style="max-width: 160px;"></v-text-field>
                            <v-menu offset-y>
                                <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                                <v-list dense nopadding>
                                    <v-list-tile>
                                        <v-list-tile-action style="min-width: 36px;">
                                            <v-checkbox v-model="includeOutOfStock" @change="fn_changeOutOfStockFilter"></v-checkbox>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Show Out of Stock</v-list-tile-title>    
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                            <!-- <v-checkbox label="Show Out of Stock" v-model="includeOutOfStock"></v-checkbox> -->
                        </v-subheader>
                        <v-divider></v-divider>
                        <v-form data-vv-scope="fields" full-width class="hasFooter">
                        <div class="pa-3 white-background" :class="{'batch_selected': batch.productQty}" v-for="(batch, index) in filteredBatches()" :key="index" full-width margin-bottom-ten v-if="showHideOutofStock(batch)">
                        <!-- <div class="pt-3 pl-3 pr-3 white-background pb-1 mb-2" v-for="(batch, index) in filteredBatches()" :key="index" full-width margin-bottom-ten> -->
                            <!-- <v-layout row wrap>
                                <v-flex xs2 sm2 md2 v-if="openingForm && batch.isNew">
                                    <v-btn class="pa-0 ma-0" icon small @click="fn_removeBatch(batch.batchId)"><v-icon>close</v-icon></v-btn>
                                </v-flex>

                                <v-flex xs2 sm2 md2 v-if="!openingForm">
                                    <v-checkbox hide-details class="ma-0" v-model="batch.selected" @change="fn_autoFillQty(batch)"></v-checkbox>
                                </v-flex>
                            </v-layout> -->
                            <div style="float: left;" :style="{'marginRight':openingForm && batch.isNew ? '12px' : '8px'}">
                                <v-btn v-if="openingForm && batch.isNew" class="pa-0 ma-0" icon small @click="fn_removeBatch(batch.batchId)"><v-icon>close</v-icon></v-btn>
                                <v-checkbox v-if="!openingForm" hide-details class="ma-0" v-model="batch.selected" @change="fn_autoFillQty(batch)"></v-checkbox>
                            </div>
                            <v-layout class="batch_layout" row wrap>
                                <!-- <v-flex xs2 sm2 md2 v-if="openingForm && batch.isNew">
                                    <v-btn class="pa-0 ma-0" icon small @click="fn_removeBatch(batch.batchId)"><v-icon>close</v-icon></v-btn>
                                </v-flex>

                                <v-flex xs2 sm2 md2 v-if="!openingForm">
                                    <v-checkbox hide-details class="ma-0" v-model="batch.selected" @change="fn_autoFillQty(batch)"></v-checkbox>
                                </v-flex> -->

                                <v-flex xs4 sm4 md4 mb-2 v-for="(field, fieldIndex) in $root.TransactionSettings.batchFields" :key="fieldIndex" v-if="field.id != 'opening' && fn_fieldVisibilty(field) && batch[field.id]">
                                    <div light-opacity-color v-if="$root.TransactionSettings.batchFields.length > 1">{{ field.title }}</div>
                                    <div v-if="field.type == 'date'">{{ batch[field.id] | moment($root.batchDateFormat) }}</div>
                                    <div v-else>{{ batch[field.id] }}</div>
                                </v-flex>
                            </v-layout>
                            <!-- <v-layout row wrap>
                                <v-flex xs4 sm4 md4 mb-3>
                                    <div light-opacity-color>Batch No.</div>
                                    <div>{{ batch.batchNumber }}</div>
                                </v-flex>
                                <v-flex xs4 sm4 md4 mb-3>
                                    <div light-opacity-color>Size</div>
                                    <div>{{ batch.batchSize }}</div>
                                </v-flex>
                                <v-flex xs4 sm4 md4 mb-3>
                                    <div light-opacity-color>MRP</div>
                                    <div>{{ batch.batchMRP }}</div>
                                </v-flex>
                                <v-flex xs4 sm4 md4 mb-3>
                                    <div light-opacity-color>Mfg. Date</div>
                                    <div>{{ batch.mfgDate | moment('DD-MMM-YYYY') }}</div>
                                </v-flex>
                                <v-flex xs4 sm4 md4 mb-3>
                                    <div light-opacity-color>Exp. Date</div>
                                    <div>{{ batch.expDate | moment('DD-MMM-YYYY') }}</div>
                                </v-flex>
                                <v-flex xs4 sm4 md4 mb-3>
                                    <div light-opacity-color>Opening</div>
                                    <div>{{ batch.opening ? batch.opening : 0 }}</div>
                                </v-flex>
                                <v-flex xs4 sm4 md4 mb-3>
                                    <div light-opacity-color>Purchase Rate</div>
                                    <div>{{ batch.purchaseRate }}</div>
                                </v-flex>
                                <v-flex xs4 sm4 md4 mb-3>
                                    <div light-opacity-color>Serial Number</div>
                                    <div>{{ batch.field1 }}</div>
                                </v-flex>
                                <v-flex xs4 sm4 md4 mb-3>
                                    <div light-opacity-color>IMEI Number</div>
                                    <div>{{ batch.field2 }}</div>
                                </v-flex>
                                <v-flex xs4 sm4 md4 mb-3>
                                    <div light-opacity-color>Part Number</div>
                                    <div>{{ batch.field3 }}</div>
                                </v-flex>
                                <v-flex xs4 sm4 md4 mb-3>
                                    <div light-opacity-color>Model Number</div>
                                    <div>{{ batch.field4 }}</div>
                                </v-flex>
                            </v-layout> -->

                            <v-layout row wrap :style="{'paddingLeft': !openingForm || batch.isNew ? '40px' : '0px'}" v-if="$parent.Form.selectedBatchType == 1">

                                <template v-if="openingForm">
                                    <v-flex xs12 sm12 md12>
                                        <v-text-field
                                            label="Opening"
                                            v-model.number="batch.opening"
                                            @input="fn_inputOpening(batch)"
                                            type="number"
                                            placeholder=" "
                                            v-validate="'min_value:0'" 
                                            data-vv-name="opening" 
                                            :error-messages="errors.collect('fields.opening')"
                                        ></v-text-field>
                                    </v-flex>
                                </template>
                                
                                <template v-else>
                                    <!-- <v-flex xs4 sm4 md4 mb-3 pr-2 :class="{'error_background':batch.currentStock<0}">
                                        <v-text-field
                                            readonly
                                            :error="batch.currentStock<0"
                                            label="Stock"
                                            :value="batch.currentStock ? batch.currentStock : 0"
                                            placeholder=" "
                                        ></v-text-field>
                                    </v-flex> -->

                                    <v-flex xs6 sm6 md6>
                                        <v-text-field
                                            label="Quantity"
                                            v-model.number="batch.productQty"
                                            @input="fn_calculateTotalQty(batch)"
                                            type="number"
                                            placeholder=" "
                                            v-validate="'min_value:0'" 
                                            data-vv-name="qty" 
                                            :hide-details="!errors.has('fields.qty')"
                                            :error-messages="errors.collect('fields.qty')"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 sm6 md6 pl-3>
                                        <v-text-field
                                            label="Unit"
                                            :disabled="true"
                                            :hide-details="!errors.has('fields.qty')"
                                            :value="productData.productVariants[0].selectedUnit ? productData.productVariants[0].selectedUnit.itemName : selectedUnit ? selectedUnit.itemName : productData.productVariants[0].unitName"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12 pt-1 pb-1 pr-2 right-align :class="{'error_background redcolor':batch.currentStock<0}">
                                        Current Stock: {{ batch.currentStock ? roundUpto2Decimals(batch.currentStock) : 0 }} {{ productData.productVariants[0].primaryUnitName }}
                                    </v-flex>
                                </template>

                                
                                <v-flex xs12 sm12 md12 redcolor pb-2 pt-2 v-if="batch.expDate && fn_checkDate(batch)">
                                    <v-icon class="mr-1 font16 redcolor">info_outline</v-icon> Expired {{ fn_getDate(batch) }}
                                </v-flex>

                                <!-- <v-flex xs12 sm12 md12 v-if="!openingForm">
                                    <v-checkbox hide-details class="ma-0" v-model="batch.selected"></v-checkbox>
                                </v-flex> -->
                            </v-layout>
                        </div>

                        </v-form>
                    </div>
        	  		
        	  	</v-card-text>

                <!-- <v-card-actions class="pa-0" v-if="fn_areFieldsAvailable()"> -->
                <v-card-actions class="pa-0">
                    <v-layout row wrap>
                        <!-- <v-flex xs12 sm12 md12> -->
                            <!-- <div class="pa-2">Total Qty: {{totalQty}}</div> -->
                            <!-- <div class="pa-2">Product Qty/Batch Qty: {{productData.productVariants[0].qty ? productData.productVariants[0].qty : 0}}/{{ totalQty }}</div> -->
                        <!-- </v-flex> -->
                         <v-flex xs6 sm6 md6 pl-3 pt-1 pb-1>
                            Total Qty:
                         </v-flex>
                         <v-flex xs6 sm6 md6 right-align pr-3 pt-1 pb-1>
                            {{totalQty}} <span v-if="productData && productData.productVariants && productData.productVariants.length">{{productData.productVariants[0].selectedUnit ? productData.productVariants[0].selectedUnit.itemName : selectedUnit ? selectedUnit.itemName : productData.productVariants[0].unitName}}</span>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-btn block flat style="height: 48px;" color="primary" @click="$parent.fn_closeDialog">Cancel</v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-btn block style="height: 48px;" color="primary" @click="fn_appendBatches">Done</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
	        </v-card>	
      	</v-dialog>
	</div>
</template>	 	

<script>

export default{
	props:['appendBatches', 'pid', 'openDatePicker', 'openingForm', 'productData', 'formType', 'selectedUnit', 'hideQty'],
	data(){	
		return{
			dialog_select_batch: false,
            batchFields:[],
            dataObj:{
                batchId:null,
                productId:null,
                batchNumber:null,
                batchMRP:null,
                mfgDate:null,
                expDate:null,
                batchSize:null,
                opening:null,
                purchaseRate:null,
                field1:null, //(serialNumber)
                field2:null, //(imeiNumber)
                field3:null, //(partNumber)
                field4:null, //(modelNumber)
                orderNumber:null,
                additionalData:null
            },
            mfgDate:null,
            expDate:null,
            includeOutOfStock:false,
            totalQty:0,
            pqty:null,
            searchValue:''
            // hasOnlySeries:true,
            // hasSeries:false
            // productBatches:null
		}
	},
	methods:{
		openDialogWeb: function () {	
            // this.fn_productBatches();
            // setTimeout(() => {
            //     if(!this.$parent.Form.batches || !this.$parent.Form.batches.length){
            //         this.fn_productBatches();
            //     }
            // }, 1000);
			this.dialog_select_batch = true;
            if(!this.batchFields || !this.batchFields.length){
                this.batchFields = [];
                if(this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
                    for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
                        if(this.$root.TransactionSettings.batchFields[i].status){
                            let obj = JSON.parse(JSON.stringify(this.$root.TransactionSettings.batchFields[i]));
                            obj.value = null;
                            this.batchFields.push(obj);
                        }
                    }
                }
            }

            if(localStorage.getItem('select_batch_filter')){
                let filterVal = localStorage.getItem('select_batch_filter');
                if(this.formType != 'outward' || filterVal == 1){
                    this.includeOutOfStock = true;
                }
                else{
                    this.includeOutOfStock = false;    
                }
                // this.includeOutOfStock = filterVal == 1 || this.formType == 'outward' ? true : false;
            }

            this.fn_calculateTotalQty();

            this.$nextTick(() => {
                let element = document.getElementsByClassName("batch_dialog_container")[0];
                element.addEventListener('scroll', this.fn_onScroll); 
            })
            

            // setTimeout(() => {
            //     if(localStorage.getItem('batch_data')){
            //         let newBatches = JSON.parse(localStorage.getItem('batch_data'));
            //         !this.$parent.Form.batches || !this.$parent.Form.batches.length ? this.$parent.Form.batches = [] : '';
            //         for(let j=0; j<newBatches.length; j++){
            //             if(newBatches[j].isNew){
            //                 newBatches[j].productQty = null;
            //                 this.$parent.Form.batches.push(newBatches[j]);
            //             }
            //             else{
            //                 let itemIndex = this.$parent.Form.batches.findIndex(item=>{return item.batchId == newBatches[j].batchId});
            //                 if(itemIndex != -1){
            //                     this.$parent.Form.batches[itemIndex] = newBatches[j];
            //                 }
            //             }
            //         }
            //         localStorage.removeItem('batch_data');
            //     }
            // }, 1000);
		},
		closeDialogWeb: function () {
			this.dialog_select_batch = false;
            this.batchFields = [];
            this.fn_emptyObject();
		},
        fn_emptyObject: function(){
            this.dataObj = {
                batchId:null,
                productId:null,
                batchNumber:null,
                batchMRP:null,
                mfgDate:null,
                expDate:null,
                opening:null,
                purchaseRate:null,
                field1:null, //(serialNumber)
                field2:null, //(imeiNumber)
                field3:null, //(partNumber)
                field4:null, //(modelNumber)
                orderNumber:null,
                additionalData:null
            }
            this.mfgDate = null;
            this.expDate = null;
            this.pqty = null;
        },

        fn_onScroll: function(){
            console.log('scrolled');
        },
        // fn_productBatches: function(){
        //     if(this.$parent.Form.batches && this.$parent.Form.batches.length){
        //         for(let i=0; i<this.$parent.Form.batches.length; i++){
        //             if(!this.$parent.Form.batches[i].productQty){
        //                 this.$parent.Form.batches[i].productQty = null;
        //             }
        //         }
        //     }
        // },
        // fn_newBatch: function(){
        //     this.$parent.backButtonPress = false;
        //     if(this.pid){
        //         this.$router.push({path:"/product/batches", query:{pid:this.pid, dialog:1, new:1}});	
        //     }
        //     else{
        //         this.$router.push({path:"/product/batches", dialog:1});
        //     }
        // },
        fn_addBatch: function(){

            this.$validator.validateAll().then((result) => {
                if (result) {
                    for(let i=0; i<this.batchFields.length; i++){
                        if(this.mfgDate && this.batchFields[i].id == 'mfgDate'){
                            this.batchFields[i].value = this.mfgDate;
                        }
                        if(this.expDate && this.batchFields[i].id == 'expDate'){
                            this.batchFields[i].value = this.expDate;
                        }
						this.dataObj[this.batchFields[i].id] = this.batchFields[i].value;
                        this.batchFields[i].value = null;
					}

                    // let items = this.this.$parent.Form.batches;

                    let existingBatch = [];
                    for(let i=0; i<this.$parent.Form.batches.length; i++){
                        let field = this.$parent.Form.batches[i];
                        if(this.$parent.Form.selectedBatchType == 1){
                            if(field.batchNumber == this.dataObj.batchNumber &&
                            field.batchMRP == this.dataObj.batchMRP &&
                            field.batchSize == this.dataObj.batchSize &&
                            this.$moment(new Date(field.mfgDate)).startOf('day').toString() == this.$moment(new Date(this.dataObj.mfgDate)).startOf('day').toString() &&
                            this.$moment(new Date(field.expDate)).startOf('day').toString() == this.$moment(new Date(this.dataObj.expDate)).startOf('day').toString() &&
                            // new Date(field.mfgDate).toString() == new Date(this.dataObj.mfgDate).toString() &&
                            // new Date(field.expDate).toString() == new Date(this.dataObj.expDate).toString() && 
                            field.field4 == this.dataObj.field4 &&
                            field.purchaseRate == this.dataObj.purchaseRate){
                                existingBatch.push(this.$parent.Form.batches[i]);
                            }
                        }
                        else{
                            if(field.field1 == this.dataObj.field1 &&
                            field.field2 == this.dataObj.field2 &&
                            field.field3 == this.dataObj.field3){
                                existingBatch.push(this.$parent.Form.batches[i]);
                            }
                        }
                    }
                    
                    // let existingBatch = this.$parent.Form.batches.filter(field=>{
                    //     if(this.$parent.Form.selectedBatchType == 1){
                    //         return field.batchNumber == this.dataObj.batchNumber &&
                    //         field.batchMRP == this.dataObj.batchMRP &&
                    //         field.batchSize == this.dataObj.batchSize &&
                    //         field.mfgDate == this.dataObj.mfgDate &&
                    //         field.expDate == this.dataObj.expDate && 
                    //         field.field4 == this.dataObj.field4 &&
                    //         field.purchaseRate == this.dataObj.purchaseRate
                    //     }
                    //     else{
                    //         return field.field1 == this.dataObj.field1 &&
                    //         field.field2 == this.dataObj.field2 &&
                    //         field.field3 == this.dataObj.field3
                    //     }
                    // })

                    let existingBatchIndex = null;
                    if(existingBatch && existingBatch.length){
                        existingBatchIndex = this.$parent.Form.batches.findIndex(item=>{return item.batchId == existingBatch[0].batchId});
                    }

                    if(existingBatchIndex != null && existingBatchIndex != -1){
                        this.$parent.Form.batches[existingBatchIndex].selected = true;
                        if(this.openingForm){
                            this.$parent.Form.batches[existingBatchIndex].opening = this.$parent.Form.selectedBatchType == 2 ?  1 : this.pqty;
                        }
                        else{
                            this.$parent.Form.batches[existingBatchIndex].productQty = this.$parent.Form.selectedBatchType == 2 ?  1 : this.pqty;
                        }
                    }
                    else{
                        if(!this.dataObj.batchId){
                            this.dataObj.batchId = this.guid();
                            this.dataObj.orderNumber = this.$parent.Form.batches.length + 1;
                            this.dataObj.isNew = true;
                            this.dataObj.selected = true;
                            // this.$parent.Form.selectedBatchType == 2 ? this.dataObj.productQty = 1 : '';
                            if(this.openingForm){
                                this.dataObj.opening = this.$parent.Form.selectedBatchType == 2 ?  1 : this.pqty;
                            }
                            else{
                                this.dataObj.productQty = this.$parent.Form.selectedBatchType == 2 ?  1 : this.pqty;
                            }
                            this.$parent.Form.batches.unshift(JSON.parse(JSON.stringify(this.dataObj)));
                        }
                    }
                    

                    this.fn_autoFillQty(this.dataObj);

                    this.fn_emptyObject();
                }
            })

            
            // !this.$parent.Form.batches || !this.$parent.Form.batches.length ? this.$parent.Form.batches = [] : '';
            // for(let j=0; j<newBatches.length; j++){
            //     if(newBatches[j].isNew){
            //         newBatches[j].productQty = null;
            //         this.$parent.Form.batches.push(newBatches[j]);
            //     }
            //     else{
            //         let itemIndex = this.$parent.Form.batches.findIndex(item=>{return item.batchId == newBatches[j].batchId});
            //         if(itemIndex != -1){
            //             this.$parent.Form.batches[itemIndex] = newBatches[j];
            //         }
            //     }
            // }
        },
        fn_appendBatches: function(){
            this.$validator.validateAll('fields').then((result) => {
                if (result) {
                    let batches = null;
                    if(this.openingForm){
                        batches = this.$parent.Form.batches;
                    }
                    else if(this.$parent.Form.selectedBatchType == 2){
                        batches = this.$parent.Form.batches.filter(item=>{return item.selected });
                    }
                    else{
                        batches = this.$parent.Form.batches.filter(item=>{return item.productQty && item.productQty > 0});
                    }

                    // if(this.$parent.Form.selectedBatchType == 2){
                    //     batches = this.$parent.Form.batches.filter(item=>{return item.selected });
                    // }
                    // else{
                    //     batches = this.$parent.Form.batches.filter(item=>{return item.productQty && item.productQty > 0});
                    // }
                    if(batches && batches.length){
                        this.appendBatches(batches);
                    }
                    else{
                        if(this.$parent.Form.batches && this.$parent.Form.batches.length){
                            this.showToast(this.$parent.Form.selectedBatchType == 2 ? "Select an item" : "Select batch and add quantity");
                        }
                        else{
                            this.showToast(this.$parent.Form.selectedBatchType == 2 ? "Add Series" : "Add Batch");
                        }
                    }
                }
            })
            
        },

        fn_fieldVisibilty: function(field){
            if(field.status){
                if(this.$parent.Form.selectedBatchType == 2){
                    if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
                else{
                    if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'opening' || field.id == 'field4'){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
            }
            else{
                return false
            }
        },

        filteredBatches: function(){
            let batches = [];
            if(this.$parent.Form.selectedBatchType == 2){
                batches = this.$parent.Form.batches.filter(field=>{
                    return !field.batchNumber && !field.batchMRP && !field.batchSize && !field.purchaseRate && !field.mfgDate && !field.expDate && !field.field4
                    // return !field.batchNumber && !field.batchMRP && !field.batchSize && !field.purchaseRate && !field.mfgDate && !field.expDate && !field.opening && !field.field4
                })
            }
            else{
                batches = this.$parent.Form.batches.filter(field=>{
                    return !field.field1 && !field.field2 && !field.field3
                })
            }
            
            let searchText = this.searchValue ? this.searchValue.toLowerCase() : '';

            if(searchText){
                return batches.filter(item => {
                    let batchNumber = item.batchNumber ? item.batchNumber.toLowerCase() : '';
                    let batchSize = item.batchSize ? item.batchSize.toLowerCase() : '';
                    let batchMRP = item.batchMRP ? item.batchMRP.toString() : '';
                    let purchaseRate = item.purchaseRate ? item.purchaseRate.toString(): '';
                    let field1 = item.field1 ? item.field1.toLowerCase() : '';
                    let field2 = item.field2 ? item.field2.toLowerCase() : '';
                    let field3 = item.field3 ? item.field3.toLowerCase() : '';
                    let field4 = item.field4 ? item.field4.toLowerCase() : '';
                    return batchNumber.match(searchText) || batchSize.match(searchText) || batchMRP.match(searchText) || purchaseRate.match(searchText) || field1.match(searchText) || field2.match(searchText) || field3.match(searchText) || field4.match(searchText);
                })
            }
            else{
                return batches;
            }
        },

        fn_updateDate: function(newValue, dateType){
            // this[dateType] = newValue;
            // let tempFields = [...this.batchFields];
            let fIndex = this.batchFields.findIndex(item=>{return item.id === dateType});
			this.batchFields[fIndex].value = newValue;
            // this.$forceUpdate();
            // this.batchFields[fIndex] = {...this.batchFields[fIndex], value:newValue};
            // this.$set(tempFields[fIndex], 'value', value);
            // this.batchFields = [...tempFields];
            // this.$forceUpdate();
            // this.batchFields = [...this.batchFields];
            // console.log(this.batchFields);
            // for(let i=0; i<this.batchFields.length; i++){
            //     if(this.batchFields[i].id === dateType){
            //         this.$set(this.batchFields[0], 'value', value);
            //         break;
            //     }
            // }
            // console.log(this.batchFields);
            // this.$parent.fn_closeDialog();
        },

        fn_removeBatch: function(batchId){
            let itemIndex = this.$parent.Form.batches.findIndex(item=>{return item.batchId === batchId});
            this.$parent.Form.batches.splice(itemIndex, 1);
            this.fn_calculateTotalQty();
        },

        fn_areFieldsAvailable: function(){
            if(this.$parent.Form.selectedBatchType == 1){
                let batches = this.batchFields.filter(field=>{
                    return field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'field4'
                })
                return batches.length ? true : false;
            }
            else{
                let series = this.batchFields.filter(field=>{
                    return field.id == 'field1' || field.id == 'field2' || field.id == 'field3'
                })
                return series.length ? true : false;
            }
        },

        fn_changeOutOfStockFilter: function(val){
            if(this.formType == 'outward'){
                localStorage.setItem('select_batch_filter', val ? 1 : 0);
            }
        },

        fn_calculateTotalQty: function(batch){

            if(batch){
                batch.selected = batch.productQty ? true : false;
            }

            this.totalQty = 0;
            let items = this.filteredBatches();
            for(let i=0; i<items.length; i++){
                if(items[i].productQty || (this.openingForm && items[i].opening)){
                    let qty = this.openingForm && items[i].opening ? items[i].opening : items[i].productQty;
                    if(!this.openingForm && items[i].selected){
                        this.totalQty =  this.totalQty + Number(qty);
                    }
                    else{
                        this.totalQty =  this.totalQty + Number(qty);
                    }
                }
            }
        },

        fn_autoFillQty: function(batch){
            if(this.productData){
                if(this.$parent.Form.selectedBatchType == 2){
                    batch.productQty = batch.selected ? 1 : null;
                }
                else{
                    if(batch.selected){
                        if(this.productData && this.productData.productVariants.length && this.productData.productVariants[0].qty){
                            if(this.totalQty < this.productData.productVariants[0].qty && batch.currentStock > 0){
                                batch.productQty =  Number(this.productData.productVariants[0].qty) - this.totalQty;
                                if(batch.productQty && batch.currentStock < batch.productQty){
                                    batch.productQty = batch.currentStock;
                                }
                            }
                        }
                    }
                    else{
                        batch.productQty = null;
                    }
                }
            }
            else{
                if(this.$route.name == 'newStockAdjustment' || this.$route.name == 'stockAdjustmentEdit'){
                    if(batch.selected && this.$parent.Form.qty){
                        if(this.totalQty < this.$parent.Form.qty){
                            batch.productQty =  Number(this.$parent.Form.qty) - this.totalQty;
                        }
                    }
                }
            }
            this.fn_calculateTotalQty();
        },

        fn_inputOpening: function(batch){
            batch.selected = batch.opening ? true : false;
            this.fn_calculateTotalQty();
        },

        showHideOutofStock: function(batch){
            if(batch.isNew){
                return true;
            }
            else{
                if(!this.includeOutOfStock){
                    return batch.currentStock > 0 ? true : false;
                }
                else{
                    return true;
                }
            }
        },

        fn_checkDate: function(batch){
            let date = this.$moment(new Date()).startOf('day');
            let eDate = this.$moment(new Date(batch.expDate)).startOf('day');
            if(date > eDate){
                return true;
            }
            else{
                return false;
            }
        },

        fn_getDate: function(batch){
            let dt = this.$moment(batch.expDate).endOf('day');
            let value = this.$moment(dt).from(new Date());
            if(value.indexOf('hours ago') != -1){
                return 'a day ago';
            }
            else{
                return value;
            }
        },

        fn_showScanner: function(field){
            let self = this;
            let filterObj = {beepOn:true};
            this.getFilterData('ScanToAddBarcode', null, filterObj,
                {
                    onSuccess: function(response){
                        console.log(response);
                        if(response && response != "Null Data Received"){
                            field.value = response.toString().trim();
                            self.$validator.reset();
                        }
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        // fn_showScanner: function (field) {
        //     var self = this;
        //     this.getData('ScanToAddBarcode', null, 
        //         {
        //             onSuccess: function(response){
        //                 console.log(response);
        //                 if(response){
        //                     field.value = response.toString().trim();
        //                     self.$validator.reset();
        //                 }
        //             }, 
        //             onError: function(error){
        //                 console.log(error);
        //             }
        //         }
        //     );
        // },

        // getStockValue: function(batch){
        //     if(batch.isNew && batch.opening){
        //         return batch.opening;
        //     }
        //     else{
        //         return batch.currentStock;
        //     }
        // }

        // getDateValue: function(field){
        //     if(field.id == 'mfgDate' && this.mfgDate){
        //         return this.mfgDate;
        //     }
        //     else if(field.id == 'expDate' && this.expDate){
        //         return this.expDate;
        //     }
        // }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_select_batch.vue